import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios'
import Konami from 'konami'
import msal from 'vue-msal'
import moment from "moment";

new Konami(function() {
  let value=localStorage.getItem('brandingOverride') ? localStorage.getItem('brandingOverride') : "0"
  localStorage.setItem('brandingOverride', value=="0" ? "1" : "0")
  window.location.reload()
});
let router=null
if(process.env.VUE_APP_CUSTOM_ROUTER){
  router=require('./config/router/'+process.env.VUE_APP_CUSTOM_ROUTER).default
} else {
  router=require('./config/router/generic').default
}

function getUrlParams(search) {
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split('=')
    return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}

if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
  let onTokenFunc = function (ctx, error, response) {
    axios.interceptors.request.use(function (config) {
      if (error == null&&!config.overrideCarnotAuth) {
        config.headers.Authorization = "Bearer " + ctx.data.accessToken;
      }
      return config;
    }, function (error) {
      return Promise.reject(error);
    });
  }
  Vue.use(msal, {
    auth: {
      clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
      authority: process.env.VUE_APP_MSAL_AUTHORITY,
      redirectUri: process.env.VUE_APP_LOGIN_REDIRECT_URL&&process.env.VUE_APP_LOGIN_REDIRECT_URL!=="" ? process.env.VUE_APP_LOGIN_REDIRECT_URL : window.location.origin,
      onToken: onTokenFunc,
      navigateToLoginRequestUrl: true
    },
    request: {
      scopes: [process.env.VUE_APP_MSAL_SCOPE]
    },
    cache: {
      cacheLocation: 'localStorage',
    }
  });

} else {
  let queryParams=getUrlParams(location.search)
  if(queryParams.token&&queryParams.token!=""){
    localStorage.setItem('pass', queryParams.token)
    history.replaceState && history.replaceState(
        null, '', location.pathname + location.search.replace(/[\?&]token=[^&]+/, '').replace(/^&/, '?') + location.hash
    )
  }
  axios.interceptors.request.use(function (config) {
    if (process.env.VUE_APP_LOGIN=='yes'&&!config.overrideCarnotAuth) {
      let pass = localStorage.getItem('pass');
      if (pass && pass !== '') {
        config.headers.Authorization = "Bearer " + pass;
      }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
}


axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (process.env.VUE_APP_LOGIN=='yes'&&error.response&&401 === error.response.status) {
    if(localStorage.getItem('pass')){
      localStorage.setItem('pass', null)
    }
    if(router.currentRoute.name!=="login") {
      router.push({
        name: 'login',
        query: {
          wantedRoute: router.currentRoute.fullPath
        },
      });
    }
  } else if (error.response&&403 === error.response.status) {
    store.dispatch('callSnackbar', {text: 'Error : This account is not allowed to access this resource'})
  } else {
    return Promise.reject(error);
  }
})

Vue.config.productionTip = false

import { abilitiesPlugin } from '@casl/vue'
import {ability} from './store/ability'
Vue.use(abilitiesPlugin, ability)

if(!process.env.VUE_APP_MOBILE_MODE){
  require('./nonessentials.js').default
}

import heatmapjsVue from 'heatmapjs-vue'
Vue.use(heatmapjsVue)

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

if(process.env.VUE_APP_INTERFACE_TRANSLATION){
  let translator = require('./translator.js').default
  translator.setup()
  Vue.filter('translate', function (value) {
    return translator.translate(value)
  })
} else {
  Vue.filter('translate', function (value) {
    return value
  })
}
Vue.filter('momentFormat', function (value,format) {
  return moment(value).format(format)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



